import React from 'react';
import { Link } from 'react-router-dom';
import { Typography, Button } from '@material-tailwind/react';

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] p-6 text-center">
      <Typography variant="h1" color="blue-gray" className="mb-4">
        404
      </Typography>
      <Typography variant="h4" color="blue-gray" className="mb-2">
        Page Not Found
      </Typography>
      <Typography color="gray" className="max-w-md mb-8">
        The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
      </Typography>
      <Link to="/">
        <Button variant="gradient" color="blue" size="lg">
          Go to Dashboard
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;